import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithDetailedLog } from "src/utils/zodErrorLogger";
import { AuditLogEntrySchema } from "./auditLogSchemas";

export const getAuditLogEntryKey = "getAuditLogEntry" as const;

type Options = {
    enabled?: boolean;
};

export const useGetAuditLogEntry = (id: string | undefined, options?: Options) => {
    const { enabled = true } = options ?? {};
    const endpoint = `/api/audit-logs/${id ?? ""}`;

    const query = useQuery({
        queryKey: [getAuditLogEntryKey, id],
        enabled: enabled && id !== undefined,
        keepPreviousData: false,
        queryFn: async () => {
            const response = await loggedInApiCall.get(endpoint);

            return zodParseWithDetailedLog(response.data, AuditLogEntrySchema, {
                operation: "GET",
                endpoint: "/api/audit-logs/{id}",
                expectedSchema: "AuditLogEntry",
            });
        },
    });

    return {
        entry: query.data,
        ...query,
    };
};
